export default __webpack_public_path__ + "static/media/glonzy-logo.beb36a52.png";